import { jsx as _jsx } from "react/jsx-runtime";
import { EmbarkProvider } from '@emburse/embark-core';
import { Outlet } from 'react-router-dom';
import { DialogProvider } from '../../components/Dialog';
import LoadingOverlayProvider from '../../providers/LoadingOverlayProvider';
import dateAdapter, { dateAdapterInstance } from '../../util/dateAdapter';
import { isEmburseProfessional } from '../../util/helpers';
const { formats, getCurrentLocaleCode } = dateAdapterInstance;
export default function BaseEmbarkView({ children }) {
    return (_jsx(EmbarkProvider, { dateLocale: {
            dateAdapter,
            adapterLocale: getCurrentLocaleCode(),
            dateFormats: formats
        }, snackbarStack: {
            autoHideDuration: 7000,
            anchorVertical: 'top'
        }, featureFlags: {
            legacyI18nSupport: true,
            useNewColorScheme: isEmburseProfessional()
        }, children: _jsx(DialogProvider, { children: _jsx(LoadingOverlayProvider, { children: children || _jsx(Outlet, {}) }) }) }));
}
